import { ReactNode } from 'react';
import MultiSelectBox from '@/components/select/MultiSelectBox';
import { SelectBoxItem, SelectBoxProps } from '@/components/select/selectBoxTypes';
import SingleSelectBox from '@/components/select/SingleSelectBox';

export type {
  CommonSelectBoxProps as OtherSelectBoxProps,
  MultiSelectBoxProps,
  MultiSelectProps,
  SelectBoxProps,
  SingleSelectBoxProps,
  SingleSelectProps,
} from '@/components/select/selectBoxTypes';
export type Item = SelectBoxItem;

const SelectBox = <T extends SelectBoxItem>(props: SelectBoxProps<T>): ReactNode => {
  if (props.multiple) {
    return <MultiSelectBox<T> {...props} />;
  }

  return <SingleSelectBox<T> {...props} />;
};

export default SelectBox;
